// services
import { AxiosInstance } from 'axios';
import AxiosInstanceCreator from 'services/api';

// models
import { BaseApiResponse } from 'modules';
import { ReqCreateUser, ReqUpdateUser, ReqUpdateUserPhoto } from 'domains/Admin';
import { ReqUserDetail, ReqUsers, ResUserDetail, ResUsers } from '../models/user.model';
import { ReqDeleteUser } from '../models/delete-user.model';

export class UserAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  async createUser(request: ReqCreateUser): Promise<BaseApiResponse> {
    const formData = new FormData();
    formData.append('user', JSON.stringify(request));
    if (request.file) {
      formData.append('file', request.file);
    }

    return this.Axios.post(`/user`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => res.data);
  }

  async updateUser(request: ReqUpdateUser): Promise<BaseApiResponse> {
    return this.Axios.put(`/user`, request).then((res) => res.data);
  }

  async updateUserPhoto(request: ReqUpdateUserPhoto): Promise<BaseApiResponse> {
    const formData = new FormData();
    formData.append('file', request.file);

    return this.Axios.put(`/user/${request.userId}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => res.data);
  }

  async fetchUsers(request: ReqUsers): Promise<ResUsers> {
    return this.Axios.get(`/user`, { params: request }).then((res) => res.data);
  }

  async fetchUserDetail(request: ReqUserDetail): Promise<ResUserDetail> {
    return this.Axios.get(`/user/detail`, { params: request }).then((res) => res.data);
  }

  async deleteUser(request: ReqDeleteUser): Promise<BaseApiResponse> {
    return this.Axios.delete(`/user`, { params: request }).then((res) => res.data);
  }
}
